import React, { FC, useCallback, useEffect, useState } from "react";
import { INftListingData } from "../../../common/interfaces/proposals.interface";
import {
  Metadata,
  MetadataData,
} from "@metaplex-foundation/mpl-token-metadata";
import solanaLogo from "../../../assets/solanaLogo.png";
import { RPC_CONNECTION } from "../../../solana/common/utilities";
import { NATIVE_MINT } from "@solana/spl-token";
import { createNotification } from "../../../utilities/notification";
import "./ListedNftItem.scss";
import { MESSAGE_TYPE } from "../../../common/constants/common.constants";
import { LAMPORTS_PER_SOL } from "@solana/web3.js";
import { copyItemToClipboard } from "../../../utilities/helpers";
const ListedNftItem: FC<{ nftListing: INftListingData }> = ({ nftListing }) => {
  const [currencyLogo, setCurrencyLogo] = useState<string>();

  useEffect(() => {
    void getCurrencyData();
  }, []);

  const copyNftListingUrl = useCallback(() => {
    try {
      const baseUrl = process.env.REACT_APP_FRONT_BASE_URL as string;
      copyItemToClipboard(
        `${baseUrl}/nft-listing?offer=${nftListing.offer.toString()}`,
        "Offer URL copied to clipboards"
      );
    } catch (error) {
      createNotification(MESSAGE_TYPE.ERROR, "Failed to copy listing url!");
    }
  }, [navigator, nftListing.offer]);

  const getCurrencyData = async () => {
    try {
      if (nftListing.wantedMint.toString() === NATIVE_MINT.toString()) {
        setCurrencyLogo(solanaLogo);
        return;
      }
      const mintMetadata = await Metadata.getPDA(nftListing.wantedMint);

      const accInfo = await RPC_CONNECTION.getAccountInfo(mintMetadata);
      if (!accInfo) return;
      const metadataAccount: Metadata = await MetadataData.deserialize(
        accInfo?.data
      );
      const jsonData = await (
        await fetch(metadataAccount.data.data.uri)
      ).json();
      setCurrencyLogo(jsonData.image);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="listed-nft-item">
      <img src={nftListing.nftData.image} alt="nft-image" />
      <div className="listed-nft-item__name">
        <p>{nftListing.nftData.name.split(" ")[0]}</p>
        <p>{nftListing.nftData.name.split(" ")[1]}</p>
      </div>
      <p className="listed-nft-item__collection">
        {nftListing.nftData.collection?.name}
      </p>
      <div className="listed-nft-item__price">
        <div className="listed-nft-item__price-logo">
          <img src={currencyLogo} alt="currency-logo" />
          <p>{nftListing.wantedAmount / LAMPORTS_PER_SOL}</p>
        </div>
        <button
          className="listed-nft-item__copy-url"
          onClick={copyNftListingUrl}
        >
          Copy URL
        </button>
      </div>
    </div>
  );
};

export default ListedNftItem;
